import { Link } from "react-router-dom";
import { useSeoMeta } from "../hooks/useSeoMeta";
import { Landscape } from "../components/landscape";
import "../components/notFound.css";

interface NotFoundPageProps {
  title?: string;
  message?: string;
}

/// Shown for unknown addresses, missing areas and unknown states
const NotFoundPage = ({
  title = "We couldn’t find that page",
  message = "The link may be old or mistyped.",
}: NotFoundPageProps) => {
  useSeoMeta({
    title: "Page not found - ClimbingWeather.com",
    description: "This page doesn't exist on ClimbingWeather.com.",
    noIndex: true,
  });

  return (
    <div className="cw-page not-found">
      <section className="not-found__panel" aria-labelledby="not-found-title">
        <div className="not-found__inner">
          <p className="not-found__code">404</p>
          <h1 className="not-found__title" id="not-found-title">{title}</h1>
          <p className="not-found__message">
            {message} Search for an area at the top of the page, or start from here:
          </p>
          <div className="not-found__actions">
            <Link to="/forecast-by-state" className="not-found__button not-found__button--primary">Browse areas by state</Link>
            <Link to="/" className="not-found__button">Go to the home page</Link>
          </div>
        </div>
        <Landscape className="not-found__landscape" />
      </section>
    </div>
  );
};

export default NotFoundPage;
